import React from 'react'
import PropTypes from 'prop-types'
import FunnelChart from '../FunnelChart'

export default function FunnelChartWithContext({children, height, data, loading}, {containerWidth}) {
  if (!data || !containerWidth) return null
  return (
    <FunnelChart width={containerWidth} height={height} data={data} loading={loading}>
      {children}
    </FunnelChart>
  )
}
FunnelChartWithContext.propTypes = {
  height: PropTypes.number,
  data: PropTypes.object,
  loading: PropTypes.bool
}
FunnelChartWithContext.contextTypes = {
  containerWidth: PropTypes.number
}



// WEBPACK FOOTER //
// ./client/components/Chart/FunnelChartTable/FunnelChartWithContext.js